import { useEffect } from 'react';

const StyleInjector = () => {
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      *, ::before, ::after {
        margin: 0;
        padding: 0;
        outline: 0;
        box-sizing: border-box;
      }
      :root {
        --light-dark-grey: #2f2f33;
        --dark-grey: #191b1f;
        --black: #000;
        --light-grey: #ebebeb;
        --nice-blue: #127cbb;
        --button-primary-disablet: #ffa582;
        --teal-blue: #009da3;
        --button-dark-disablet: #a9a6b5;
        --color-blue-dark: #53a3ff;
        --color-blue: #007aff;
        --button-default-hover: #f4f4f4;
        --button-default-normal: #f0f0f0;
        --button-default-press: #ddd;
        --button-default-disablet: #d2d2d2;
        --button-default-dark: rgba(0, 0, 0, 0.4);
        --button-secondary-disablet: #7daeff;
        --bg-white: #fff;
        --bg-page-2: #e9e9e9;
        --charcoal-grey: #2d2d30;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return null;
};

export default StyleInjector;
